module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Da mihi castitatem et continentiam, sed noli modo!")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Saint Augustine of Hippo, "), _c('i', [_vm._v("The Confessions")])]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("To acknowledge today that there is failure—not an end, nothing is finished—is to recognize that there is hope. My logic here, don’t forget, is also the logic of Augustine: as long as there is anxiety, there is hope.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Paul Virilio, "), _c('i', [_vm._v("The Accident of Art")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d78f0f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-gunn-0007.vue
// module id = 72
// module chunks = 0